import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AisVesselsComponent } from './ais-vessels.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExpansionPanelModule } from "src/app/shared/components/expansion-panel/expansion-panel.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AisVesselsRoutingModule } from './ais-vessels-routing.module';
import { MatSortModule } from '@angular/material/sort';



@NgModule({
  declarations: [
    AisVesselsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatPaginatorModule,
    ExpansionPanelModule,
    FormsModule,
    ReactiveFormsModule,
    AisVesselsRoutingModule,
    MatSortModule
],
  exports:[
    AisVesselsComponent
  ]
})
export class AisVesselsModule { }
